import { useMessage } from "../../../hooks/useMessage";
import { CHANGE_DELETE, DELETE } from "../../../services";

export const useDelete = () => {
  const { openMessage } = useMessage();

  const onDelete = async (mainId: string): Promise<boolean> => {
    try {
      const res = await DELETE(CHANGE_DELETE(mainId));
      openMessage("success", res.message);
      return true;
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.error);
      return false;
    }
  };

  return {
    onDelete,
  };
};
